/**
 * The Carousel function
 */
(function($) {
    $.fn.c24Carousel = function() {
        $(this).each(function(_, parent) {
            const _$parent = $(parent);
            const _$wrap = _$parent.find('.box24Wrap');
            let _$elems = _$parent.find('.box24Item');
            const _$dots = _$parent.find('.box24Progress .box24Dot');
            const _timer = _$parent.data('timer');
            let _started = false;
            let _clicked = false;
            let _busy = false;
            let _animationLeft = 0;
            const _finiteSlider = _$parent.hasClass('finite');
            const _itemCount = $(_$elems[_$elems.length - 1]).data('dot');

            const _shift = function(where) {
                if (!_busy) {
                    _busy = true;
                    let clone;
                    if (where > 0) {
                        const $cut = _$elems.slice(_$elems.length - where, _$elems.length);
                        clone = $cut.clone();
                        const _width = $cut.outerWidth();
                        _reGroup(where);
                        _$wrap.css({
                            'left': _width * where * -1,
                        });
                        _animationLeft = 0;
                    } else {
                        const $cut = _$elems.slice(0, where * - 1);
                        clone = $cut.clone();
                        const _width = $cut.outerWidth();
                        _animationLeft = _width * where;
                    }

                    clone.appendTo(_$wrap);

                    _$wrap.animate({
                        left: _animationLeft,
                    }, function() {

                        if (where < 0) {
                            _reGroup(where);
                        }
                        _$wrap.css({
                            'left': '',
                        });

                        clone.remove();
                        _busy = false;
                    });
                }
            };
            const _reGroup = function(where) {
                if (where < 0) {
                    const $cut = _$elems.slice(0, where * -1);
                    $cut.detach();
                    _$parent.find('.box24Wrap').append($cut);
                } else {
                    const $cut = _$elems.slice(_$elems.length - where, _$elems.length);
                    $cut.detach();
                    _$parent.find('.box24Wrap').prepend($cut);
                }

                _$elems = _$parent.find('.box24Item'); // re-init

                if (_$dots.length) {
                    _$dots.removeClass('active');
                    _$parent.find('.box24Progress .box24Dot.dot' + $(_$elems[0]).data('dot')).addClass('active');
                }
            };
            const _shiftSlide = function(where) {
                if (!_finiteSlider) {
                    _shift(where);
                } else {
                    if (where < 0) {
                        const $cut = _$elems.slice(0, where * - 1);
                        _$parent.find('.box24Prev').css('display', 'block');
                        if (!$cut.hasClass('item' + _itemCount)) {
                            if ($cut.hasClass('item' + (_itemCount - 1))) {
                                _$parent.find('.box24Next').css('display', 'none');
                            }
                            _shift(where);
                        }
                    } else {
                        const $cut = _$elems.slice(_$elems.length - where, _$elems.length);
                        _$parent.find('.box24Next').css('display', 'block');
                        if (!$cut.hasClass('item' + _itemCount)) {
                            if ($cut.hasClass('item1')) {
                                _$parent.find('.box24Prev').css('display', 'none');
                            }
                            _shift(where);
                        }
                    }
                }
            };

            if (_$wrap.hasClass('autoheight')) {
                let iHeight = 0;
                $.each(_$elems, function() {
                    iHeight = Math.max(iHeight, $(this).height());
                });
                _$wrap.css('height', iHeight + 'px');
            }

            _$parent.find('.box24Next').on('click', function(e) {
                e.preventDefault();
                _clicked = true;
                _shiftSlide(-1);
            });
            _$parent.find('.box24Prev').on('click', function(e) {
                e.preventDefault();
                _clicked = true;
                _shiftSlide(1);
            });

            if (_$parent.hasClass('swipeable')) {
                _$parent.c24Swipe('swipeRight', function() {
                    _clicked = true;
                    _shiftSlide(1);
                });
                _$parent.c24Swipe('swipeLeft', function() {
                    _clicked = true;
                    _shiftSlide(-1);
                });
            }

            if (_$dots.length) {
                $('.box24Progress .box24Dot', _$parent).on('click', function() {
                    const currentDot = $(_$elems[0]).data('dot');
                    const targetDot = $(this).data('dot');
                    if (currentDot !== targetDot) {
                        _shiftSlide(currentDot - targetDot);
                    }
                });
            }

            if (typeof _timer !== 'undefined' && _timer !== null) {

                if (_started == false &&
                    $(window).scrollTop() > _$parent.offset().top - $(window).height() + (_$parent.height() / 2)) {
                    _started = true;
                    setInterval(function() {
                        if (_clicked == false) {
                            _shiftSlide(-1);
                        }
                    }, _timer);
                }

                $(document).on('scroll', function() {
                    if (_started == false &&
                        $(window).scrollTop() > _$parent.offset().top - $(window).height() + (_$parent.height() / 2)) {
                        _started = true;
                        setInterval(function() {
                            if (_clicked == false) {
                                _shiftSlide(-1);
                            }
                        }, _timer);
                    }
                });
            }

            if (_$parent.hasClass('complete') && !_$parent.hasClass('fixedgap')) {
                let _elemWidthOriginal = 0;
                _$elems.each(function(index, ele) {
                    const outerWidth = $(ele).outerWidth();
                    if (outerWidth > _elemWidthOriginal) {
                        _elemWidthOriginal = outerWidth;
                    }
                });

                const _reSize = function() {
                    const _availableWidth = $('.box24Wrap', _$parent).width();
                    const _$visibleItems = Math.floor(_availableWidth / _elemWidthOriginal);
                    const _width = (_availableWidth / _$visibleItems);
                    _$elems.each(function(_, elem) {
                        $(elem).css('min-width', _width + 'px');
                    });
                };

                _reSize();
                $(window).on('resize', _reSize);
            }

        });
    };
})(window.jQuery);
